import React from 'react';
import './FormFieldError.scss';

const FormFieldError = ({message = null}) => {
  return message && <p className='field__error'>{message}</p>;
};

export default FormFieldError;
